export const sleep = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
//# sourceMappingURL=sleep.js.map